<script lang="ts" setup>
  import { InputWidthVariant } from '../../InputWrapper';
  import type { SelectFieldProps, SelectModelValue } from './Select.types.ts';
  import { useField } from 'vee-validate';
  import { toRef, toRefs } from 'vue';
  import Select from './Select.vue';

  const emit = defineEmits<{
    'update:modelValue': [value: SelectModelValue];
  }>();

  const props = withDefaults(defineProps<SelectFieldProps>(), {
    value: undefined,
    rules: undefined,
    searchable: true,
    clearOnSelect: true,
    closeOnSelect: true,
    showLabels: false,
    showNoOptions: true,
    showNoResults: true,
    allowEmpty: false,
    taggable: false,
    disabled: false,
    meta: undefined,
    internalSearch: true,
    width: InputWidthVariant.FULL,
  });

  const {
    name: inputName,
    label,
    rules,
    ...rest
  } = toRefs<SelectFieldProps>(props);
  // workaround to keep reactivity on rest value from toRefs
  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<string>(inputName.value, rules?.value, {
    label: label?.value,
  });

  const onUpdateModelValue = (value: SelectModelValue) => {
    handleChange(value);
    emit('update:modelValue', value);
  };
</script>

<template>
  <Select
    v-bind="inputProps"
    :error="errorMessage as string"
    :label="label"
    :meta="meta"
    :loading="loading"
    :model-value="inputValue as string"
    :name="name"
    :open-direction="openDirection"
    :placeholder="placeholder"
    @blur="handleBlur"
    @update:modelValue="onUpdateModelValue"
  >
    <template #option="optionProps">
      <slot name="option" v-bind="optionProps"></slot>
    </template>
    <template #extraLabel> <slot name="extraLabel"></slot> </template>
  </Select>
</template>
